import API from '@aws-amplify/api'

import config from 'aws-exports'

const API_URL = config.Api.endpoint
const API_NAME = 'api_gateway'
API.configure({
  endpoints: [
    {
      name: API_NAME,
      endpoint: API_URL,
      region: 'eu-central-1',
    },
  ],
})

export const verifyEmail = async (userId: string) => {
  const response = await API.post(API_NAME, `/verifymail/${userId}`, {
    body: {}
  })
  return response as any
}

export const emailVerified = async (userId: string) => {
  const response = await API.get(API_NAME, `/verifymail/${userId}/status`, {
  })
  return response as {
    status: 'VERIFIED' | 'PENDING' | 'UNVERIFIED'
    email: string
  }[]
}

export const revokeEmailVerification = async (userId: string) => {
  const response = await API.post(API_NAME, `/revokemail/${userId}`, { body: {}})
  return response as any
}
